import React, { useState } from "react";

import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import ViewPresentation from "./ViewPresentation";
import ModalElement from "../Modal";

const GeneratePresentation = ({ presentation }) => {

    const [viewPresentationOpen, setViewPresentationOpen] = useState(false)

    const handleClose = () => {
        setViewPresentationOpen(false)
    }

    const toggleViewPresentationOpen = () => {
        setViewPresentationOpen(!viewPresentationOpen)
    }

    function renderPresentationModal() {
        return (
            <ModalElement
                modalOpen={viewPresentationOpen}
                modalWidth={1200}
                handleClose={handleClose}
                header="Presentation"
                // instruction="Please be as detailed as possible"
                content={
                    <ViewPresentation
                        presentation={presentation}
                    />
                }
            />
        )
    }

    return (
        <Box>
            <Button startIcon={<AutoGraphIcon />} variant="contained" onClick={toggleViewPresentationOpen} sx={{ textTransform: 'none' }}>Generate Presentation</Button>
            {renderPresentationModal()}
        </Box>
    )
}

export default GeneratePresentation